export const Tags = {
    "Solid food": {
      id: 1,
      trash_bin: 'Compost Bin',
      bin_image: 'https://media.istockphoto.com/id/1368576326/vector/cartoon-dumpster-with-food-garbage-illustration-for-food-processing-and-compost-organic.jpg?s=612x612&w=0&k=20&c=eyFhSxxSoajGl1Ongb5Fo4J2sXx0nKDp9UTKObT9KdU=',
      fact: 'You can put your solid food waste in the composting bin. This includes food scraps, egg shells, coffee grounds, and tea bags. Composting is a great way to reduce your carbon footprint and help the environment.',
    },
    "Fabric":
    {
      id: 2,
      trash_bin: "Donation Box",
      bin_image: 'https://www.recyclingbin.com/core/media/media.nl?id=231159&c=889942&h=A0hkx6HTgYcoATiXOHOKM-wME-z4A2YE0NAOXvULl5M7zZOy',
      fact: "You can put your fabric in the donation box. This includes clothes, shoes, and other textiles. Donating your clothes is a great way to help those in need and reduce your carbon footprint.",
    },
  
    "Metal":
    {
      id: 3,
      trash_bin: "Recycle Bin",
      bin_image : "https://www.wikihow.com/images/thumb/a/a7/Recycle-Metals-Step-3-Version-2.jpg/v4-460px-Recycle-Metals-Step-3-Version-2.jpg.webp",
      fact: "You can place these metals in your home recycling bin or be taken to a local recycling depot. This includes aluminum cans, steel cans, and tin cans. Recycling metals is a great way to reduce your carbon footprint and help the environment.",
    },
    "Paper":
    {
      id: 4,
      trash_bin:"Recycle Bin",
      bin_image: 'https://images.thdstatic.com/productImages/e74c180c-7ad9-4252-a3b9-48a18deaa238/svn/rubbermaid-recycling-bins-rcp295773blue-64_1000.jpg',
      fact: "Clean paper with long textile can be recycled if sorted properly. This includes newspapers, magazines, and cardboard. Recycling paper is a great way to reduce your carbon footprint and help the environment.",
    },
    "Plastic":
    {
      id: 5,
      trash_bin: "Recycle Bin",
      bin_image: 'https://images.thdstatic.com/productImages/e74c180c-7ad9-4252-a3b9-48a18deaa238/svn/rubbermaid-recycling-bins-rcp295773blue-64_1000.jpg',
      fact: "This includes plastic bottles, plastic bags, and plastic containers. Recycling plastic is a great way to reduce your carbon footprint and help the environment.",
    },
    "Hazardous chemical":
    {
      id: 6,
      trash_bin: 'Hazardous Waste Disposal Bin',
      bin_image:"https://www.conserve-energy-future.com/wp-content/uploads/2015/05/hazardous-waste-disposal-e1430994120635.jpg",
      fact: "You can donate this items to manufacturers and retailers of computers, smart phones, TVs and other electronics for recycling. This includes batteries, light bulbs, and electronics. Recycling electronics is a great way to reduce your carbon footprint and help the environment.",
    },
    "Liquid":
    {
      id: 7,
      trash_bin: 'Liquid Disposal Bin, or Drain, or Trash Only',
      bin_image:"https://us.glasdon.com/images/products/400/combo-tm-liquid-reservoir-recycling-bin-main.jpg",
      fact: "Liquid can disturb the recycling process, create unpleasant odors in the trash bins, and attract pests. Therefore, we have to dispose liquid properly when sorting trash."
    },
    "Non-recyclable":
    {
      id: 7,
      trash_bin: 'Trash only bin',
      bin_image:"https://m.media-amazon.com/images/I/51K4e3PF6eL._SL1500_.jpg",
      fact: "Non-recyclable items are items that cannot be recycled. This includes plastic bags, plastic wrap, and styrofoam. Non-recyclable items should be disposed of in the trash bin.",
    },
  };
  